export const update = (data) => ({
  type: "DISTRIBUTION_DETAILS/UPDATE",
  payload: data,
});

export const clear = () => ({
  type: "DISTRIBUTION_DETAILS/CLEAR",
  payload: {},
});
